import { CallableInput } from "Components/Shared";
import FormSubmit from "Components/Shared/FormSubmit";
import OutboundProxySelect from "Components/Shared/OutboundProxySelect";
import { Field, Formik } from "formik";
import { useVoiceRegion } from "Hooks/Endpoints";
import React from "react";
import { Form } from "semantic-ui-react";

const OutboundRouteEditForm = () => {
  const {
    outboundRoute,
    updateOutboundRoute,
    voiceRegion,
    unselectOutboundRoute,
    removeOutboundRoute,
  } = useVoiceRegion();
  return (
    <Formik
      validateOnChange={false}
      initialValues={outboundRoute}
      enableReinitialize={true}
      onSubmit={(values, actions) => {
        updateOutboundRoute(values);
      }}
    >
      {({ handleSubmit, errors, validateField, values }) => (
        <Form onSubmit={handleSubmit}>
          <Field
            name='caller'
            label='Caller'
            placeholder='*'
            component={CallableInput}
          />

          <Field
            name='called'
            label='Called'
            placeholder='*'
            component={CallableInput}
          />

          <Field
            name='diversion'
            label='Diversion'
            placeholder='441234567890'
            component={CallableInput}
          />

          <OutboundProxySelect
            name='obp'
            label='Proxy'
            proxies={voiceRegion.proxies}
          />

          <FormSubmit
            name='Update'
            errors={errors}
            onCancel={() => unselectOutboundRoute()}
            onDelete={() => removeOutboundRoute(outboundRoute.id)}
          />
        </Form>
      )}
    </Formik>
  );
};

export default OutboundRouteEditForm;
